import type { LawFirm } from '@common/types/lawfirms';
import { useQuery } from '@tanstack/react-query';
import { fetchAllLawFirms, fetchLawFirmById, fetchLawFirmList } from '@/services/LawfirmService';

export function useLawFirm(lawFirmId?: number) {
    return useQuery<LawFirm | null>({
        queryKey: ['lawFirm', lawFirmId],
        queryFn: async () => {
            if (!lawFirmId) return null;
            return fetchLawFirmById(lawFirmId);
        },
        enabled: !!lawFirmId,
        staleTime: 5 * 60_000,
    });
}

export function useLawFirms(includeTestFirms: boolean) {
    return useQuery<LawFirm[]>({
        queryKey: ['lawFirms', includeTestFirms ? 'include-test-firms' : 'exclude-test-firms'],
        queryFn: () => fetchAllLawFirms(includeTestFirms),
        staleTime: 5 * 60_000,
    });
}

export function useLawFirmList(enabled = true) {
    return useQuery<LawFirm[]>({
        queryKey: ['lawFirms', 'admin-list'],
        queryFn: fetchLawFirmList,
        enabled,
        staleTime: 5 * 60_000,
    });
}
